export default __webpack_public_path__ + "static/Rectangle 1061-58bc108cb7187f7ce1e3d7587db840a3.png";